'use strict';
/* eslint-disable */

/**
 * Informs OG a product has been removed from the cart
 */
function removeFromCart() {
	$('.item-user-actions .remove').on('click', function () {
		var productID = $(this).parents('.cart-row').data('pid');
        if (window.OG && window.OG.removeFromCart) {
            window.OG.removeFromCart({
                id: productID
            }, {isAjax: false});
        }
    });
}
/**
 * Informs OG a product quantity has changed
 */
function updateCart() {
	$('.update-qty').on('click', function () {
		var productRow = $(this).parents('.cart-row'),
			productID = $(productRow).data('pid'),
			quantity = $(productRow).find('.item-quantity-details .input-group input').val();
        if (window.OG && window.OG.updateCart) {
            window.OG.updateCart({
                id: productID,
                module: 'sc',
                quantity: quantity
            }, {isAjax: false});
        }
    });
}

module.exports = {
	init: function () {
		removeFromCart();
		updateCart();
	}
};
